var _path, _ellipse, _ellipse2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.237 16c0-2.113 1.704-3.826 3.805-3.826h9.168c5.445 0 9.859 4.438 9.859 9.913 0 5.475-4.414 9.913-9.86 9.913h-2.94c-2.101 0-3.805-1.713-3.805-3.826s1.704-3.826 3.805-3.826h2.94a2.255 2.255 0 0 0 2.25-2.261 2.255 2.255 0 0 0-2.25-2.261H8.043c-2.101 0-3.805-1.713-3.805-3.826Z",
  fill: "#1182F6"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.9,
  cx: 4.583,
  cy: 3.826,
  rx: 3.805,
  ry: 3.826,
  fill: "#FFB800"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.9,
  cx: 4.583,
  cy: 28.174,
  rx: 3.805,
  ry: 3.826,
  fill: "#F53149"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.464 3.826C10.464 1.713 12.168 0 14.269 0h2.94c5.446 0 9.86 4.438 9.86 9.913 0 5.475-4.414 9.913-9.86 9.913H8.043c-2.101 0-3.805-1.713-3.805-3.826s1.704-3.826 3.805-3.826h9.168a2.255 2.255 0 0 0 2.248-2.261 2.255 2.255 0 0 0-2.248-2.26h-2.94c-2.102 0-3.806-1.714-3.806-3.827Z",
  fill: "#623CEA"
})));
export default SvgLogoIcon;